import AvatarList from './avatar-list';

export default AvatarList;
